import { CertificazioneDto, CertificazioneEmailDto, CertificazioniDettaglioDto, ClienteDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { DettaglioClienteReducerType } from "./types";

const dettaglioClienteReducer = (state: RootState): DettaglioClienteReducerType => state.dettaglioCliente;

export const flagButtonAvviaCertificazioneSelector = createSelector(
  dettaglioClienteReducer,
  (state: DettaglioClienteReducerType): CertificazioniDettaglioDto | undefined => {
    return state.flagButtonAvviaCertificazione;
  }
);

export const resultInvioEmail = createSelector(
  dettaglioClienteReducer,
  (state: DettaglioClienteReducerType): CertificazioneEmailDto | undefined => {
    return state.resultInvioEmail;
  }
);

export const clienteDtoSelector = createSelector(
  dettaglioClienteReducer,
  (state: DettaglioClienteReducerType): ClienteDto | undefined => {
    return state.dettaglioCliente;
  }
);

export const elencoCertificazioniClienteSelector = createSelector(
  dettaglioClienteReducer,
  (state: DettaglioClienteReducerType): CertificazioneDto[] => {
    return state.elencoCertificazioniCliente;
  }
);

export const resultAvvioCertificazioneSelector = createSelector(
  dettaglioClienteReducer,
  (state: DettaglioClienteReducerType): CertificazioneEmailDto | void => {
    return state.resultAvvioCertificazione;
  }
);
